import * as React from 'react';

const FigmaIcon = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#24CB71",
        d: "M4 16a3 3 0 0 1 3-3h3v3a3 3 0 0 1-6 0"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF7237",
        d: "M10 1v6h3a3 3 0 0 0 0-6z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#00B6FF",
        d: "M12.98 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FF3737",
        d: "M4 4a3 3 0 0 0 3 3h3V1H7a3 3 0 0 0-3 3"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#874FFF",
        d: "M4 10a3 3 0 0 0 3 3h3V7H7a3 3 0 0 0-3 3"
    }));

export { FigmaIcon };
//# sourceMappingURL=Figma.mjs.map
